import { appVariant } from '../config';
import type { AppVariant } from '../config/types';

const PACK_BACKGROUND_URLS: Record<AppVariant, string> = {
  blitz: '/assets/bg/blitz-pack-bg.png',
  party: '/assets/bg/party-pack-bg.png',
  team: '/assets/bg/team-pack-bg.png',
  family: '/assets/bg/family-pack-bg.png',
  coop: '/assets/bg/coop-pack-bg.png',
};

/** Public URL for the current pack's lobby / host backdrop image. */
export function getPackBackgroundUrl(variant: AppVariant = appVariant): string {
  return PACK_BACKGROUND_URLS[variant] ?? PACK_BACKGROUND_URLS.blitz;
}

/** Applies pack backdrop CSS variable on `<html>` (avoids CRA css-loader resolving public URLs). */
export function applyPackBackground(variant: AppVariant = appVariant): void {
  const url = getPackBackgroundUrl(variant);
  document.documentElement.dataset.pack = variant;
  document.documentElement.style.setProperty('--pack-bg-image', `url("${url}")`);
}
